import { Icon } from '@design-system';
import classNames from 'classnames';
import React, {
  FC,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useState,
} from 'react';
import { useUpdateEffect } from 'react-use';

export interface SimpleDropDownMenuItem {
  key?: string;
  node: ReactNode;
  onClick: () => void;
}

interface SimpleDropDownMenuProps {
  items: SimpleDropDownMenuItem[];
  lastItemDivider?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

/**
 * @deprecated Use @design-system/Fields/Select
 */
export const SimpleDropDownMenu: FC<
  PropsWithChildren<SimpleDropDownMenuProps>
> = ({ children, items, lastItemDivider, onClose, onOpen }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleRootButtonClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [setIsOpen, isOpen]);

  const handleListItemClick = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleEvents = () => {
    if (isOpen && onOpen) {
      onOpen();
    }
    if (!isOpen && onClose) {
      onClose();
    }
  };

  useUpdateEffect(() => {
    handleEvents();
  }, [isOpen]);

  return (
    <div>
      <button
        className="flex w-full items-center justify-between rounded-sm border border-divider/20 bg-white px-3 py-3 hover:bg-neutral-1"
        onClick={handleRootButtonClick}
        type="button"
      >
        {children ?? <div />}
        <Icon name={isOpen ? 'ic_chevron_up' : 'ic_chevron_down'} />
      </button>

      {isOpen && (
        <div className="relative">
          <div className="absolute z-50 mt-2 w-full rounded-sm border border-divider/20 bg-white py-2">
            {items.map((item, index) => (
              <div
                key={item.key ? item.key : index}
                className={classNames('px-2', {
                  'last:mt-2 last:border-t last:border-divider/20 last:pt-2':
                    lastItemDivider && items.length > 1,
                })}
              >
                <button
                  className="flex w-full rounded-sm px-2 py-2 hover:bg-neutral-1"
                  onClick={() => {
                    handleListItemClick();
                    item.onClick();
                  }}
                  type="button"
                >
                  {item.node}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
